// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  name: __t.string(),
  online: __t.bool(),
  rating: __t.i32(),
  wins: __t.u32(),
  losses: __t.u32(),
  balance: __t.i32(),
  balanceKind: __t.string().name("balance_kind"),
  accountId: __t.string().name("account_id"),
  seasonPoints: __t.u32().name("season_points"),
});
